import { Container, Title, Text, Card, Stack, Group, List, ThemeIcon, Button, Divider } from "@mantine/core";
import { IconBulb, IconClick, IconMailFast, IconFileDescription, IconWritingSign, IconMessageCircleCog } from '@tabler/icons-react';
import { useLocation } from 'wouter';

export default function AboutPage() {
    const [, setLocation] = useLocation();
    return (
        <Container fluid w={{ base: 400, md: 600 }}>
            <Title>About MyYenta</Title>
            <Text size="lg" c="dimmed" mb="xl">Personality & behavior insights to connect smarter & outsmart the competition!</Text>

            <Card shadow="sm" m='auto' p="lg" radius="md" withBorder mb="xl">
                <Title order={2} mb="md">What is MyYenta?</Title>
                <Divider my="md" />
                <Text>
                    MyYenta is a powerful platform designed for real estate professionals. Our system helps you understand your clients' preferences and communication styles, enabling you to build stronger relationships and close more deals.
                </Text>
            </Card>
            <Group justify="center" my="xl">
                <Button
                    size="md"
                    radius="md"
                    onClick={() => setLocation("/login")}
                >Sign Up Now</Button>
            </Group>
            <Title order={2} pb="lg">How MyYenta Works for You</Title>
            <Stack gap="lg" m='auto' mb="xl" justify="center" align="center" >
                <Card shadow="sm" p="md" radius="md" withBorder w='100%'>
                    <Group wrap="nowrap">
                        <ThemeIcon size="xl" radius="md" color="cyan">
                            <IconMailFast size={24} />
                        </ThemeIcon>
                        <Stack gap={0} ta='center'>
                            <Text fw={700}>1. Send potential clients your link</Text>
                            <Text>Your myYenta link provides them your information and then...</Text>
                        </Stack>
                    </Group>
                </Card>

                <Card shadow="sm" p="md" radius="md" withBorder w='100%'>
                    <Group wrap="nowrap">
                        <ThemeIcon size="xl" radius="md" color="blue">
                            <IconClick size={24} />
                        </ThemeIcon>
                        <Stack gap={0}>
                            <Text fw={700}>2. They answer a few questions</Text>
                            <Text>It's fun, easy, & takes only 5 to 10 minutes and after that...</Text>
                        </Stack>
                    </Group>
                </Card>

                <Card shadow="sm" p="md" radius="md" withBorder w='100%'>
                    <Group wrap="nowrap">
                        <ThemeIcon size="xl" radius="md" color="indigo">
                            <IconFileDescription size={24} />
                        </ThemeIcon>
                        <Stack gap={0}>
                            <Text fw={700}>3. You get a complete report!</Text>
                            <Text>Going over your new client and how best to work with them!</Text>
                        </Stack>
                    </Group>
                </Card>

                <Card shadow="sm" p="md" radius="md" withBorder w='100%'>
                    <Group wrap="nowrap">
                        <ThemeIcon size="xl" radius="md" color="violet">
                            <IconWritingSign size={24} />
                        </ThemeIcon>
                        <Stack gap={0}>
                            <Text fw={700}>Easier Contract Signing</Text>
                            <Text>Easily build a connection and understanding to shorten the sales cycle.</Text>
                        </Stack>
                    </Group>
                </Card>

                <Card shadow="sm" p="md" radius="md" withBorder w='100%'>
                    <Group wrap="nowrap">
                        <ThemeIcon size="xl" radius="md" color="grape">
                            <IconMessageCircleCog size={24} />
                        </ThemeIcon>
                        <Stack gap={0}>
                            <Text fw={700}>Tailor your approach</Text>
                            <Text>Understand your clients' communication preferences and personalities.</Text>
                        </Stack>
                    </Group>
                </Card>

                <Card shadow="sm" p="lg" radius="md" withBorder mb="xl" w={{ base: 410, sm: 450, md: 650}}>
                    <Title order={3}>Benefits for Real Estate Professionals</Title>
                    <Divider my="md" />
                    <List spacing="md" ta='left' m='auto'>
                        <List.Item icon={
                            <ThemeIcon color="cyan" size={24} radius="xl">
                                <IconBulb size={16} />
                            </ThemeIcon>
                        }>
                            <Text fw={500}>Increase client satisfaction by understanding their unique needs</Text>
                        </List.Item>
                        <List.Item icon={
                            <ThemeIcon color="cyan" size={24} radius="xl">
                                <IconBulb size={16} />
                            </ThemeIcon>
                        }>
                            <Text fw={500}>Reduce time wasted on mismatched property showings</Text>
                        </List.Item>
                        <List.Item icon={
                            <ThemeIcon color="cyan" size={24} radius="xl">
                                <IconBulb size={16} />
                            </ThemeIcon>
                        }>
                            <Text fw={500}>Build a reputation as a realtor who truly listens to clients</Text>
                        </List.Item>
                        <List.Item icon={
                            <ThemeIcon color="cyan" size={24} radius="xl">
                                <IconBulb size={16} />
                            </ThemeIcon>
                        }>
                            <Text fw={500}>Generate more referrals through exceptional client experiences</Text>
                        </List.Item>
                        <List.Item icon={
                            <ThemeIcon color="cyan" size={24} radius="xl">
                                <IconBulb size={16} />
                            </ThemeIcon>
                        }>
                            <Text fw={500}>Close deals faster by improving client-agent communication</Text>
                        </List.Item>
                    </List>
                </Card>
                <Button
                    size="md"
                    radius="md"
                    onClick={() => setLocation("/login")}
                >Sign Up Now</Button>
            </Stack>

        </Container>
    );
}
